export default "__VITE_ASSET__BOcjw2Bp__"